export default __webpack_public_path__ + "static/media/past-due-date-icon.a8edb0bc.svg";